<template>
  <div
    id="js-navbar-topgap"
    class="c-pt-4 hidden c-lg:block"
  />
  <nav
    id="js-navbar"
    class="navbar navbar--basket hidden c-lg:block"
    :class="{ 'is-fixed': isFixed }"
  >
    <div class="overflow-hidden">
      <div
        class="hidden c-lg:block absolute c-w-100 c-h-100"
        :class="backgroundColor"
        :style="{ opacity: isFixed ? 1 : 0 }"
      />
      <div class="container">
        <div class="form-row c-flex-nowrap c-items-center c-py-1 c-lg:c-py-0 c-lg:c-mx-0 c-xxl:c-px-5">
          <Logo />

          <!-- text -->
          <div class="col c-lg:c-pr-4">
            <p class="h1 c-m-0 text-white text-center whitespace-nowrap uppercase">
              {{ t('order') }}
            </p>
          </div>

          <!-- rightside of navbar (menu, login, favourite, basket, language,..) -->
          <div class="navbar__rightside col-auto c-ml-auto c-px-0 c-lg:c-pl-5 hidden c-lg:flex c-self-stretch">
            <div class="flex c-flex-col c-justify-center c-flex-grow-1 relative">
              <div class="form-row c-items-center">
                <Toolbar type="short" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import Logo from '@/components/menus/navbar/TheNavbarLogo.vue'
import Toolbar from '@/components/menus/navbar/TheNavbarToolbar.vue'
import { useNavbarStore } from '@/stores/NavbarStore'

const { t } = useI18n()
const navbarStore = useNavbarStore()
const topGap = ref({})
const isFixed = ref(false)

const { backgroundColor } = storeToRefs(navbarStore)

const observe = () => {
  topGap.value = document.querySelector('#js-navbar-topgap')
  const observer = new IntersectionObserver(toggleFixedState)
  observer.observe(topGap.value)
}

const toggleFixedState = (entries) => {
  for (const entry of entries) {
    isFixed.value = !entry.isIntersecting
  }
}

onMounted(() => {
   observe()
})
</script>

<i18n>
  {
    "cs": {
    "order": "Rekapitulace objednávky"
},
    "sk": {
    "order": "Rekapitulácia objednávky"
},
    "pl": {
    "order": "Podsumowanie zamówienia"
},
    "hu": {
    "order": "A megrendelés összefoglalása"
},
    "de": {
    "order": "Zusammenfassung der Bestellung"
},
    "at": {
    "order": "Zusammenfassung der Bestellung"
},
    "ro": {
    "order": "Sumar al comenzii"
},
    "fr": {
    "order": "Récapitulatif de la commande"
},
    "it": {
    "order": "Riepilogo dell'ordine"
}
  }
</i18n>
